const urlGeolocation = "https://pro.ip-api.com/json/?key=Mxv35AIAv0Tdx0f";

export const getGeolocation = () =>
  $.ajax({
    method: "GET",
    url: urlGeolocation,
  });
